import { render } from "./SearchWithDropdownFilter.vue?vue&type=template&id=51e23bd5"
import script from "./SearchWithDropdownFilter.vue?vue&type=script&lang=js"
export * from "./SearchWithDropdownFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__